import { render, staticRenderFns } from "./DurationPicker.vue?vue&type=template&id=6b2051c5&"
import script from "./DurationPicker.vue?vue&type=script&lang=js&"
export * from "./DurationPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports